/**
 * Colour roles for the Characters world ("Toy town", ART-BIBLE §5.3): toy-block red / blue / yellow,
 * brick, roof red, tree green, lamp gold. Storybook (A) values; B and C are derived by `rolePalette`.
 * Shared roles (skin, hair, mouth, tongue, eye, blush, white, scarf, sparkle…) come from the base palette.
 */
import { rolePalette } from '../../art/palette';

export const CHARACTERS_PALETTE = rolePalette({
  // toy blocks (shared by several kids' outfits)
  toyRed: '#E9785B',
  toyBlue: '#5AAFD9',
  toyYellow: '#F2C14E',
  toyGreen: '#7FB86A',
  toyNavy: '#3E5A86',
  toyRoof: '#C94F5B',
  // people
  skinWarm: '#C98A62',
  hairBrown: '#7A4A32',
  hairGinger: '#D9783F',
  charFreckle: '#B56A4A',
  // robot
  robotBody: '#6FB7D9',
  robotDark: '#3F7FB3',
  robotPanel: '#E8EEF4',
  // astronaut
  suitWhite: '#F2EFEA',
  suitGrey: '#B7C1CE',
  visorGlass: '#BFDDEE',
  // wizard
  wizardPurple: '#8366C2',
  wizardDark: '#5B4796',
  wandWood: '#A8734E',
  // pirate
  pirateHat: '#4A3F55',
  pirateGold: '#E8B33F',
  beardGinger: '#C9652F',
  beardDark: '#9A4A26',
  parrotGreen: '#5FAE5A',
  pirateBoot: '#6E4733',
  // chef
  chefWhite: '#FBF8F2',
  chefCheck: '#D9585A',
  pieCrust: '#E3A35C',
  pieBerry: '#B0466A',
  // hero + runner
  heroRed: '#E0584E',
  heroCape: '#B9394A',
  heroBlue: '#4C7FD0',
  runnerShorts: '#3F9C9A',
  // doodles
  carRed: '#E35F52',
  carTyre: '#4E4652',
  carHubcap: '#D9DEE5',
  snowmanWhite: '#F7FAFC',
  snowmanShadow: '#D6E3EE',
  snowmanCarrot: '#EE8A3C',
  snowmanHat: '#4A4458',
  snowmanTwig: '#8A5A3C',
  // v2 cast (Toy Town residents): skin tones, hair, outfits and props
  chSkinDeep: '#8D5A3B',
  chSkinLight: '#F2C9A8',
  chHairBlack: '#3A2A2C',
  chHairGrey: '#C9C4C2',
  chFireCoat: '#E8B64A',
  chFireStripe: '#E9EEF2',
  chHelmet: '#D9503F',
  chBoot: '#4A3F55',
  chHose: '#C77D4A',
  chBrass: '#E0A93A',
  chWater: '#8CCBE6',
  chPot: '#D47E55',
  chSmock: '#8FC3D8',
  chBeret: '#C94F5B',
  chPalette: '#E8C08A',
  chDancer: '#E98AA5',
  chSkirt: '#F6C1CD',
  chRibbon: '#4FB3A9',
  chRibbonB: '#F2C14E',
  chBlock: '#E7BE80',
  chBlockDark: '#C98E52',
  chFrog: '#7CC06A',
  chFrogBelly: '#CDE7A8',
  chNightcap: '#7D8FD0',
  chFeather: '#FFFDF6',
  chKitten: '#F0A456',
  chCake: '#F3B4C4',
  chCream: '#FFF4E2',
  chMap: '#F3E3BE',
  chChair: '#4C7FD0',
  chWheel: '#4E4652',
  chSkate: '#F4F1EA',
  chTeddy: '#C98B5A',
  chTeddyLight: '#EED3B2',
  chMirror: '#E0B45A',
  chBalloon: '#E9785B',
  chBalloonB: '#5AAFD9',
  chPea: '#8CC46A',
});
